import {coachingApi} from '../api';
import {List} from 'immutable';
import CoachingReview from 'records/CoachingReview';
import CoachingReviewAnswer from 'records/CoachingReviewAnswer';
import CoachingReviewFileUpload from 'records/CoachingReviewFileUpload';

export default {
  updateReviewFileUploads(reviewId, reviewFileUploads) {
    return coachingApi.putJson(`/reviews/${reviewId}/fileuploads`, reviewFileUploads.toJS()).then(
      ({callFeedback}) => [
        reviewId,
        List(callFeedback.map(reviewFileUpload => new CoachingReviewFileUpload(reviewFileUpload))),
      ],
      error => {
        // eslint-disable-next-line
        throw [reviewId, error];
      }
    );
  },
  deleteReviewFileUpload(reviewId, fileUploadId) {
    return coachingApi.deleteJson(`/reviews/${reviewId}/fileuploads/${fileUploadId}`).then(
      ({callFeedback}) => [
        reviewId,
        List(callFeedback.map(reviewFileUpload => new CoachingReviewFileUpload(reviewFileUpload))),
      ],
      error => {
        // eslint-disable-next-line
        throw [reviewId, error];
      }
    );
  },
  saveForLater(review, reviewFileUpload) {
    return coachingApi
      .putJson(`/reviews/${review.id}/fileuploads/${reviewFileUpload.fileuploadId}/save-for-later`)
      .then(
        ({callFeedback}) => [
          review,
          List(
            callFeedback.map(reviewFileUpload => new CoachingReviewFileUpload(reviewFileUpload))
          ),
        ],
        error => {
          // eslint-disable-next-line
          throw [review, error];
        }
      );
  },
  /**
   *
   * @param reviewId - the review id containing the review file
   * @param reviewFileUploadId - the id of the review file
   * @param contentDetailIds - the new set of content details ids to include in the review
   *   should be an js array
   * @returns {*}
   */
  changeFileReviewSkills(reviewId, reviewFileUploadId, contentDetailIds) {
    return coachingApi
      .putJson(
        `/reviews/${reviewId}/feedback/${reviewFileUploadId}/change-skills`,
        {},
        {params: {contentDetailIds}}
      )
      .then(
        ({callFeedback}) => [
          reviewId,
          List(
            callFeedback.map(reviewFileUpload => new CoachingReviewFileUpload(reviewFileUpload))
          ),
        ],
        error => {
          // eslint-disable-next-line
          throw [reviewId, error];
        }
      );
  },
  fetchReviewFeedback(reviewId) {
    return coachingApi
      .getJson(`/reviews/${reviewId}/feedback`)
      .then(
        ({
          callFeedback: reviewFileUploads,
          questionFeedback: coachingReviewAnswers,
          highLevelScores,
        }) => ({
          reviewFileUploads: List(
            reviewFileUploads.map(
              reviewFileUpload => new CoachingReviewFileUpload(reviewFileUpload)
            )
          ),
          coachingReviewAnswers: List(coachingReviewAnswers).map(
            reviewTypeAnswer => new CoachingReviewAnswer(reviewTypeAnswer)
          ),
          highLevelScores: List(highLevelScores),
        })
      );
  },
  submitFeedback(review, reviewFileUploads, reviewTypeAnswers) {
    return coachingApi
      .putJson(`/reviews/${review.id}/feedback`, {
        callFeedback: reviewFileUploads.flatMap(r => r.reviewFeedbackList).toJS(),
        questionFeedback: reviewTypeAnswers.toJS(),
      })
      .then(({callFeedback, questionFeedback}) => ({
        reviewFileUploads: List(callFeedback).map(
          reviewFileUpload => new CoachingReviewFileUpload(reviewFileUpload)
        ),
        coachingReviewAnswers: List(questionFeedback).map(
          reviewTypeAnswer => new CoachingReviewAnswer(reviewTypeAnswer)
        ),
      }))
      .catch(error => {
        // eslint-disable-next-line
        throw [review, error];
      });
  },
  updateReview(review) {
    return coachingApi.putJson(`/reviews/${review.id}`, review.toJS()).then(
      review => new CoachingReview(review),
      error => {
        // eslint-disable-next-line
        throw [review, error];
      }
    );
  },
  rescheduleReview(review) {
    return coachingApi.putJson(`/reviews/${review.id}/reschedule`, review.toJS()).then(
      review => new CoachingReview(review),
      error => {
        // eslint-disable-next-line
        throw [review, error];
      }
    );
  },
  startReview(reviewId) {
    return coachingApi.post(`/reviews/${reviewId}/start`);
  },
  deleteReview(reviewId) {
    return coachingApi.delete(`/reviews/${reviewId}`);
  },
  cancelReview(reviewId) {
    return coachingApi.post(`/reviews/${reviewId}/cancel`);
  },

  setLiveCoachingStubs(reviewId, stubs) {
    return coachingApi
      .putJson(`/reviews/${reviewId}/live-coaching-stubs/${stubs}`)
      .then(review => new CoachingReview(review));
  },
};
